import { IconeProprio, type PropsIcone } from './base'

/**
 * Ícone próprio de prancha longa de resgate veicular (spine board).
 *
 * Desenhada com contorno anatômico autêntico de salvamento: cabeceira ovalada,
 * estreitamento cervical, ombros alargados com alças de transporte, cintura ergonômica,
 * afunilamento em direção às pernas, recesso/entalhe central nos pés (para puxada
 * e saída pelo porta-malas), canal espinhal de alívio e tiras de imobilização.
 * Evita formato retangular/cápsula para não ser confundida com celular ou controle.
 */
export function IconeExtracao(props: PropsIcone) {
  return (
    <IconeProprio {...props}>
      {/* Contorno anatômico esculturado: cabeceira, estreitamento cervical, ombros, afunilamento e entalhe podálico */}
      <path d="M9.5 2.5h5c1.2 0 1.8.8 1.8 1.8 0 .8-.5 1.3-.9 1.6.8.7 1.8 1.8 1.8 3.5 0 1.8-.7 2.8-1 3.5.3 1.2 0 2.2-.6 3.5-.5 1.2-1.2 2.5-1.8 3.8l-.3 1.3c-.2.5-.6.5-1 .3L12 20.5l-.5 1.3c-.4.2-.8.2-1-.3l-.3-1.3c-.6-1.3-1.3-2.6-1.8-3.8-.6-1.3-.9-2.3-.6-3.5-.3-.7-1-1.7-1-3.5 0-1.7 1-2.8 1.8-3.5-.4-.3-.9-.8-.9-1.6 0-1 .6-1.8 1.8-1.8z" />

      {/* Orifício central de fixação do imobilizador de cabeça */}
      <circle cx="12" cy="4.5" r="0.9" />

      {/* Canal longitudinal de alívio da coluna vertebral (eixo sagital) */}
      <path d="M12 6.5v12" />

      {/* Alças superiores ergonômicas de empunhadura (tórax) */}
      <rect x="7.4" y="8" width="1.4" height="2.8" rx="0.7" />
      <rect x="15.2" y="8" width="1.4" height="2.8" rx="0.7" />

      {/* Alças médias de empunhadura (pelve) */}
      <rect x="7.8" y="12.2" width="1.4" height="2.8" rx="0.7" />
      <rect x="14.8" y="12.2" width="1.4" height="2.8" rx="0.7" />

      {/* Alças inferiores de empunhadura (membros inferiores) */}
      <rect x="8.3" y="16.2" width="1.3" height="2.4" rx="0.65" />
      <rect x="14.4" y="16.2" width="1.3" height="2.4" rx="0.65" />

      {/* Ancoragens transversais para o tirante de imobilização */}
      <path d="M10.2 9.4h3.6" />
      <path d="M10.4 13.6h3.2" />
    </IconeProprio>
  )
}

/** Sinônimo do equipamento de prancha longa. */
export const IconePranchaLonga = IconeExtracao

/** Compatibilidade com o registro de módulos. */
export const IconeModuloExtracao = IconeExtracao
